import { useQuery } from '@tanstack/react-query'
import { consoleApi, apiErrorMessage } from '../../api/client'
import { EmptyState, ErrorState, LoadingState } from '../../components/common/AsyncState'
import { PageHeader } from '../../components/common/PageHeader'
import { ServiceCard } from '../../components/public/ServiceCard'

export function ServiceLaunchpadPage() {
  const query = useQuery({
    queryKey: ['console', 'services'],
    queryFn: consoleApi.services,
    refetchInterval: 60_000,
  })
  return (
    <>
      <PageHeader
        eyebrow="FreeIPA-authorized catalogue"
        title="Service launchpad"
        description="Launch links are returned by the API only when your current FreeIPA groups satisfy each service policy."
      />
      {query.isLoading && <LoadingState />}
      {query.isError && <ErrorState message={apiErrorMessage(query.error)} />}
      {query.data &&
        (query.data.length ? (
          <div className="service-grid">
            {query.data.map((service) => (
              <ServiceCard key={service._id} service={service} launch />
            ))}
          </div>
        ) : (
          <EmptyState
            title="No services available"
            description="Ask the platform administrator to review the service catalogue and your group membership."
          />
        ))}
    </>
  )
}
